import { api } from '../core';
import { MEDICAL_MATCH_LIVE_STATUS_TAG } from '../constants';

/**
 * Why an ad-hoc live question can't be asked right now. A `null` reason on the
 * response means live questions are available.
 */
export enum LiveMedicalMatchBlockedReason {
  FULL_MEDMATCH_IN_PROGRESS = 'FULL_MEDMATCH_IN_PROGRESS',
  LIVE_MEDMATCH_IN_PROGRESS = 'LIVE_MEDMATCH_IN_PROGRESS',
  NO_FULL_MEDMATCH_JOB = 'NO_FULL_MEDMATCH_JOB',
  CACHE_MISSING = 'CACHE_MISSING',
  DAILY_LIMIT_REACHED = 'DAILY_LIMIT_REACHED',
}

export interface CanRunLiveMedicalMatchResponse {
  canRun: boolean;
  reason: LiveMedicalMatchBlockedReason | null;
}

interface GetCanRunLiveMedicalMatchRequest {
  caseId: string;
}

const getCanRunLiveMedicalMatchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCanRunLiveMedicalMatch: builder.query<CanRunLiveMedicalMatchResponse, GetCanRunLiveMedicalMatchRequest>({
      query: ({ caseId }: GetCanRunLiveMedicalMatchRequest) => ({
        url: `medical-match-custom/can-run-live-medmatch?caseId=${encodeURIComponent(caseId)}`,
        method: 'GET',
      }),
      providesTags: (_result, _err, { caseId }) => [{ type: MEDICAL_MATCH_LIVE_STATUS_TAG, id: caseId }],
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

export const { useGetCanRunLiveMedicalMatchQuery } = getCanRunLiveMedicalMatchApi;
